import type { components } from '@heidi/schema/ml-scribe';
import { useMutation } from '@tanstack/react-query';

import { ehrMutationKeys } from '../../contracts/queryKeys';

type SessionUpdate = components['schemas']['SessionUpdate'];

type DetailVariables = {
  sessionId: string;
  appointmentId?: string;
  patientId?: string;
  provider?: string;
  encounterId?: string;
  ehrApptContactId?: string;
};

export function useMutateUpdateSessionEHRDetails<TResult>(options: {
  updateSession: (sessionId: string, body: SessionUpdate) => Promise<TResult>;
  onMutate?: (variables: DetailVariables) => unknown;
  onError?: (error: unknown, variables: DetailVariables) => void;
}) {
  return useMutation({
    mutationKey: ehrMutationKeys.updateSessionEhrDetails(),
    mutationFn: async ({
      sessionId,
      appointmentId,
      patientId,
      provider,
      encounterId,
      ehrApptContactId,
    }: DetailVariables) => {
      return await options.updateSession(sessionId, {
        ehr_provider: provider,
        ehr_appt_id: appointmentId,
        ehr_patient_id: patientId,
        ehr_encounter_id: encounterId,
        ehr_appt_contact_id: ehrApptContactId,
      });
    },
    onMutate: options.onMutate,
    onError: options.onError,
  });
}
